import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { taxesEnabled, getTaxPercentage } from '../../data/purchase-service';
import { getConfiguration, getCurrencyValue } from '../../data/utils';
import { getLabel } from '../../data/labels';

function PotentialWinBox(props) {
	const betslipContext = useContext(BetslipContext) ;
    let betslipData = betslipContext.getBetslipData();
    const conf = getConfiguration();
    const couponKey = props.couponKey;
    const container = props.container;
    const coupon = betslipData.coupons[couponKey];
	const totalTaxAmount = coupon.totalTaxAmount? coupon.totalTaxAmount : 0;
	const showTaxes = taxesEnabled() && totalTaxAmount > 0;
    
    let potentialWinning = getCurrencyValue(coupon.potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMin =  getCurrencyValue(coupon.minPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let potentialWinMax =  getCurrencyValue(coupon.maxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let amountSrc = 0;
    
    const stakeTaxedJustAdvice = betslipContext.stakeTaxConfiguration.enabled && 
    							 betslipContext.stakeTaxConfiguration.type === 'advice_for_online_distro';
    
    const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	 							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
    
    let stakeTaxedAmountSrc = 0;
    let stakeTaxedPotentialWinning = 0;
    // let stakeTaxedMinPotentialWinning = 0; // only for systembets
    // let stakeTaxedMaxPotentialWinning = 0; // only for systembets
    
    // bonusMulti
    let bonusDataMulti = null;
    let potentialWinningNoBonusMulti = 0;
    let bonusWinMulti = 0;
    let descBonusMulti = "Bonus";
    
    // bonusSystem
    let bonusSystemData = null;
    let descBonusSystem = "Bonus";
    
    if (container === 'singlebets') {
    	amountSrc = coupon.amountSingle;
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSingle;
    	}
    } else if (container === 'multibets') {
    	amountSrc = coupon.amountMulti;
    	bonusDataMulti = coupon.multipleBonus;
    	if (bonusDataMulti != null && bonusDataMulti.applied) {
    		potentialWinningNoBonusMulti = getCurrencyValue(bonusDataMulti.potentialWinningNoBonus, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		bonusWinMulti = getCurrencyValue(bonusDataMulti.bonusAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
    		descBonusMulti = bonusDataMulti.description;
    	}
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountMulti;
    	}
    } else {
    	amountSrc = coupon.amountSystem;
    	bonusSystemData = coupon.bonusSystemData;
    	if (bonusSystemData != null && bonusSystemData.applied) {
    		descBonusSystem = bonusSystemData.description != null && bonusSystemData.description !== '' ? bonusSystemData.description : descBonusSystem;
    	} else {
    		bonusSystemData = {
    			applied : false	
    		};
    	}
    	
    	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
    		stakeTaxedAmountSrc = coupon.stakeTaxedAmountSystem;
    	}
    }
    
    let totalAmount = getCurrencyValue(amountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
    let stakeTaxedTotalAmount = null;
    const showTaxedTotalAmount = stakeTaxedForPurchase; // TO remove definetely if in the future we wont have a skin that requires it
	if (stakeTaxedJustAdvice || stakeTaxedForPurchase) {
		stakeTaxedTotalAmount = getCurrencyValue(stakeTaxedAmountSrc, conf.cs.m, conf.cs.nd, conf.cs.ct);
		stakeTaxedPotentialWinning = getCurrencyValue(coupon.stakeTaxedPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		// stakeTaxedMinPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMinPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		// stakeTaxedMaxPotentialWinning =  getCurrencyValue(coupon.stakeTaxedMaxPotentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
	}
    const varOddSelectedClass = 'bg-nero bianco';
    const varOddUnselectedClass = 'bg-grigio-chiaro nero';
    
    //const [varOdd, changeVarOdd] = useState('never');
    
    let varOdd = coupon.oddVariation;
    
    function changeVarOdd(oddVariation) {
    	betslipContext.changeOddVariation(oddVariation, true);
    }

    function handleToggle() {
        let oddVariation = coupon.oddVariation;
        if (oddVariation === 'NEVER') {
            oddVariation = 'ALWAYS';
        } 
        else {
            oddVariation = 'NEVER';
        }
    	betslipContext.changeOddVariation(oddVariation, true);
    }

    let taxedStakeAmountLabel = getLabel('betslip.taxed_stake');
    let taxedStakeWinningLabel = getLabel('betslip.taxed_stake_winning');
    if(stakeTaxedJustAdvice || stakeTaxedForPurchase){
    	taxedStakeAmountLabel = taxedStakeAmountLabel.replace(/{{PERCENTAGE}}/g,  betslipContext.stakeTaxConfiguration.percentage / 100 + "%");
    }
    
    
    // MAX PAID STUFF, IF THE CUSTOMER HAS IT IN ITS CONFIGURATION
    let maxPaidPotentialWinning = null;
    let maxPaidPotentialWinMin =  null;
    let maxPaidPotentialWinMax =  null;
    let maxPaidStakeTaxedPotentialWinning = null;
    
    if(container === 'systembets' ){
    	if(conf.sbmw !== 0 && conf.mwspw){
    		if(coupon.potentialWinning > conf.sbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.minPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMin = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.maxPotentialWinning > conf.sbmw){
    			maxPaidPotentialWinMax = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.sbmw){
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.sbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    else{
    	if(conf.mbmw !== 0 && conf.mwmpw){
    		if(coupon.potentialWinning > conf.mbmw){
    			maxPaidPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    		if(coupon.stakeTaxedPotentialWinning > conf.mbmw){
    			maxPaidStakeTaxedPotentialWinning = getCurrencyValue(conf.mbmw, conf.cs.m, conf.cs.nd, conf.cs.ct);    			
    		}
    	}
    }
    
    const hideVariationPicker = betslipContext.isBetBuilder() || (window.appConfig?.TERMINAL_AGENCY && conf.rs?.dovpo);
    return (
        <div className="vincita-potenziale">
	    	{container === 'multibets' &&
	        	<>
					 <div className="box-vincita-potenziale d-sx">{getLabel('carrello.total_odds')}</div>
			         <div className="box-vincita-potenziale d-dx">
			         	<span className="grassetto">{coupon.totalOdd}</span>
			         </div>	
	        	</>
	    	}  
	    	<div className="box-vincita-potenziale testo-importo-totale-carrello d-sx">{getLabel('carrello.total_amount')}</div>
				<div className="box-vincita-potenziale valore-importo-totale-carrello d-dx grassetto">
				<span className="">{totalAmount}</span>
			</div>
			{showTaxedTotalAmount &&
                <>
					<div className="box-vincita-potenziale testo-importo-totale-carrello d-sx">{taxedStakeAmountLabel}</div>
					<div className="box-vincita-potenziale valore-importo-totale-carrello d-dx grassetto">
						<span className="">{stakeTaxedTotalAmount}</span>
					</div>
				</>
			}
        	{container === 'systembets' &&
	        	<>
                    <div className="box-vincita-potenziale d-sx">{getLabel('carrello.combs')}</div>
                    <div className="box-vincita-potenziale d-dx">
                        <span className="">{coupon.totalCombs}</span>
                    </div>	
                    <div className="box-vincita-potenziale d-sx">{getLabel('carrello.min_winnings')}</div>
                    <div className="box-vincita-potenziale d-dx">
                        <span className="">{maxPaidPotentialWinMin? maxPaidPotentialWinMin: potentialWinMin}</span>
                    </div>	
                    <div className="box-vincita-potenziale d-sx">{getLabel('carrello.max_winnings')}</div>
                    <div className="box-vincita-potenziale d-dx">
                        <span className="">{maxPaidPotentialWinMax? maxPaidPotentialWinMax : potentialWinMax}</span>
                    </div>	
                    {bonusSystemData.applied &&
                        <>
                            <div className="box-vincita-potenziale d-sx grassetto">{descBonusSystem.toUpperCase()}</div> <div className="box-vincita-potenziale d-dx"></div>
                            <div className="box-vincita-potenziale d-sx">{"Bonus Min."} </div>
                            <div className="box-vincita-potenziale d-dx">{getCurrencyValue((bonusSystemData.bonusMin * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                            <div className="box-vincita-potenziale d-sx">{"Bonus Max."}</div>
                            <div className="box-vincita-potenziale d-dx">{getCurrencyValue((bonusSystemData.bonusMax * conf.cs.m), conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        </>
                    }
	        	</>
        	}
        	{(container === 'multibets' && bonusDataMulti != null && bonusDataMulti.applied) &&
                <>
                    <div className="box-vincita-potenziale d-sx d-none">{getLabel('carrello.winnings')}</div>
                    <div className="box-vincita-potenziale d-dx d-none">{potentialWinningNoBonusMulti}</div>
                    <div className="box-vincita-potenziale d-sx grassetto">{descBonusMulti}</div>
                    <div className="box-vincita-potenziale d-dx">{bonusWinMulti}</div>
        		</>
        	}
        	{showTaxes &&
                <>
                    <div className="box-vincita-potenziale d-sx">{getLabel('printer.plain_ticket.footer.gross_winnings')}</div>
                    <div className="box-vincita-potenziale d-dx">{getCurrencyValue(coupon.potentialWinning + totalTaxAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                    <div className="box-vincita-potenziale d-sx">{getLabel('printer.plain_ticket.footer.tax')} {'(' + getTaxPercentage() + ')'}</div>
                    <div className="box-vincita-potenziale d-dx">{getCurrencyValue(totalTaxAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                </>
            }
            <div className="box-vincita-potenziale testo-vincita-potenziale-carrello d-sx">{getLabel('carrello.potential_winnings')}</div>
            <div className="box-vincita-potenziale valore-vincita-potenziale-carrello d-dx">
            	<span className="grassetto verde">
            		{stakeTaxedForPurchase? (maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning) : (maxPaidPotentialWinning? maxPaidPotentialWinning : potentialWinning)}
            	</span>
            </div>
            {stakeTaxedJustAdvice &&
                <>
	                <div className="box-vincita-potenziale testo-vincita-potenziale-carrello d-sx">{taxedStakeWinningLabel}</div>
	                <div className="box-vincita-potenziale valore-vincita-potenziale-carrello d-dx">
	                	<span className="grassetto verde">{maxPaidStakeTaxedPotentialWinning? maxPaidStakeTaxedPotentialWinning : stakeTaxedPotentialWinning}</span>
	                </div>
            	</>
            }
            {
            	!hideVariationPicker  && <>
		            {conf.ovs?.tgs ?
		                <>
		                    <div className="d-flex align-items-center">
		                        <span>{getLabel('carrello.odds_variation_toggle.label')}</span>
		                    </div>
		                    <div className="d-flex align-items-center">
		                        <label className="custom-switch-2 ml-auto">
		                            <input type="checkbox" checked={coupon.oddVariation !== 'NEVER'} onChange={handleToggle} />
		                            <span className="custom-slider-2 round"></span>
		                        </label>
		                    </div>
		                </>
		                :
		                <div className="container-variazioni-quote">
		                    <div className="box-vincita-potenziale testo-var-quote">{getLabel('carrello.odds_variation')}</div>
		                    <div className="box-vincita-potenziale testo-piccolo bottoni-var-quote">
		                        <a onClick={() => changeVarOdd('NEVER')} className={"bottone px-2 " +( varOdd === 'NEVER'? varOddSelectedClass : varOddUnselectedClass )+ " margine-dx-mezzo"}>
		                            {getLabel('carrello.accept_odds_variation.never')}
		                        </a>
		                        <a onClick={() => changeVarOdd('ALWAYS')} className={"bottone px-2 " +( varOdd === 'ALWAYS'? varOddSelectedClass : varOddUnselectedClass )+ " margine-dx-mezzo"}>
		                            {getLabel('carrello.accept_odds_variation.always')}
		                        </a>
		                        <a onClick={() => changeVarOdd('INCR')} className={"bottone px-2 " + (varOdd === 'INCR'? varOddSelectedClass : varOddUnselectedClass)}>
		                            {getLabel('carrello.accept_odds_variation.increasing')}
		                        </a>
		                    </div>
		                </div>
		            }
            	</>
            }

        </div>
    );
}

export default PotentialWinBox;